import React from "react";
import Employs from "./Employs";

const HomeEmploys = () => {
  return <Employs />;
};

export default HomeEmploys;
